// extracted by mini-css-extract-plugin
export default {"w-full":"TopDevice_w-full__s73jl","chart":"TopDevice_chart__jKltw","legend":"TopDevice_legend__ML4tD","title":"TopDevice_title__67PdP","percent":"TopDevice_percent__Jgf3s"};